import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, formatApiErrorDetail } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "admin@theteakstudio.com", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(form.email, form.password);
      if (u.role !== "admin") { toast.error("Not an admin account"); setBusy(false); return; }
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Sign-in failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "#0B0B0C" }} data-testid="admin-login-page">
      <div className="w-full max-w-md p-12" style={{ background: "#141414", border: "1px solid var(--hairline)" }}>
        <div className="font-micro text-[#B8895C] mb-4">The Studio · Admin</div>
        <h1 className="font-serif text-[#EDE4D3] text-4xl mb-10">Sign in.</h1>
        <form onSubmit={submit} className="space-y-6">
          <input className="input-teak" type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-login-email" />
          <input className="input-teak" type="password" placeholder="Password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-login-password" />
          <button className="btn-bronze w-full" type="submit" disabled={busy} data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
